import React from 'react';
import { Col, Modal, Row, Button, FormControl, Spinner } from 'react-bootstrap';
import { cancellationReasonOptions } from '../../../../../helpers/constants';

const OrderCancellationConfirmationModal = ({
  show,
  onHide,
  dateOfCancellation,
  onDateOfCancellationChange,
  reason,
  onReasonChange,
  priceFieldName = 'Hard Cost',
  price,
  onPriceChange,
  onSubmit,
  showProgress
}) => {
  return (
    <>
      <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton={!showProgress}>
          <Modal.Title>Please provide details of cancellation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 style={{ fontSize: 14 }}>Date of cancellation</h6>
          <FormControl
            type="date"
            size="sm"
            value={dateOfCancellation}
            onChange={e => onDateOfCancellationChange(e.target.value)}
          />
          <h6 style={{ fontSize: 14 }} className="mt-2">
            Reason
          </h6>
          <select
            onChange={e => onReasonChange(e.target.value)}
            className="form-control form-control-sm"
            value={reason}
          >
            {cancellationReasonOptions.map(r => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
          <h6 style={{ fontSize: 14 }} className="mt-2">
            {priceFieldName}
          </h6>
          <FormControl type="number" size="sm" value={price} onChange={e => onPriceChange(e.target.value)} />
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col>
              <Button disabled={showProgress} variant="secondary" onClick={onHide} className="mr-2">
                Go Back
              </Button>
              <Button
                disabled={showProgress}
                variant="danger"
                onClick={onSubmit}
                className="d-inline-flex align-items-center justify-content-center"
              >
                {showProgress && <Spinner size="sm" animation="border" className="mr-1" />}
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrderCancellationConfirmationModal;
